export default __webpack_public_path__ + "static/media/ml.26e44660.svg";